import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';

import notificationTargetURL from '../../misc/notificationTargetURL';
import WaitWhileBusy from '../WaitWhileBusy';

const NotificationsRedirector = props => {
    const {notificationId} = props,
        notification = useSelector(state => state.notifications.all.find(notif => notif.id == notificationId)),
        data = notification?.content?.data,
        eventId = data?.eventId;

    // mark unread notifications as read
    useEffect(() => {
        if (notification && !notification.read) {
            app.api.notifications.markRead(notification.id);
        }
    }, [notification]);

    let path;
    try {
        path = notificationTargetURL(data || {});
    } catch (e) {
        if (eventId) {
            path = ['/events', eventId].join('/');
        } else {
            path = '/';
        }
    }

    return <Redirect to={path} />;
};

export default props => (
    <WaitWhileBusy>
        <NotificationsRedirector {...props.match.params} />
    </WaitWhileBusy>
);
